var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdminManage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7667 6.52313H18.6936V10.2154H25.7667V6.52313Z",
    fill: "#BEE6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4974 15.3039H18.6936V18.9962H27.4974V15.3039Z",
    fill: "#BEE6FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.94 23.577H17.99V27.2693H28.94V23.577Z",
    fill: "#BEE6FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6936 10.4347H25.7667V8.47313V6.52313H18.6936V8.47313V10.4347Z",
    stroke: "#24293D",
    strokeWidth: 1.44231,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6936 19.1116H27.4859V17.15V15.2H18.6936V19.1116Z",
    stroke: "#24293D",
    strokeWidth: 1.44231,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.99 27.5231H28.94V25.5731V23.6116H17.99",
    stroke: "#24293D",
    strokeWidth: 1.44231,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05525 7.27312C8.28278 7.2731 8.50116 7.36269 8.66313 7.52249C8.82509 7.68229 8.9176 7.89946 8.92064 8.12696C8.92064 8.35648 8.82946 8.57659 8.66717 8.73888C8.50488 8.90117 8.28477 8.99235 8.05525 8.99235C7.82574 8.99235 7.60562 8.90117 7.44333 8.73888C7.28104 8.57659 7.18987 8.35648 7.18987 8.12696C7.1929 7.89946 7.28541 7.68229 7.44738 7.52249C7.60934 7.36269 7.82772 7.2731 8.05525 7.27312ZM8.05525 5.83081C7.59883 5.83081 7.15267 5.96615 6.77317 6.21973C6.39367 6.4733 6.09789 6.83371 5.92322 7.25539C5.74856 7.67706 5.70286 8.14106 5.7919 8.58871C5.88094 9.03636 6.10073 9.44755 6.42347 9.77029C6.7462 10.093 7.1574 10.3128 7.60504 10.4019C8.05269 10.4909 8.51669 10.4452 8.93837 10.2705C9.36004 10.0959 9.72046 9.80009 9.97403 9.42059C10.2276 9.04109 10.3629 8.59492 10.3629 8.1385C10.3629 7.52646 10.1198 6.93949 9.68704 6.50672C9.25426 6.07394 8.66729 5.83081 8.05525 5.83081Z",
    fill: "#24293D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0552 15.1423V12.8347C11.0538 12.7089 11.027 12.5847 10.9765 12.4696C10.926 12.3544 10.8527 12.2506 10.7612 12.1645C10.6696 12.0783 10.5616 12.0115 10.4436 11.968C10.3256 11.9245 10.2 11.9054 10.0744 11.9116H5.98979C5.74192 11.9116 5.50419 12.01 5.32892 12.1853C5.15364 12.3606 5.05518 12.5983 5.05518 12.8462V15.1539",
    stroke: "#24293D",
    strokeWidth: 1.44231,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05525 20.4616C8.28384 20.4646 8.50222 20.5567 8.66387 20.7183C8.82552 20.88 8.91765 21.0984 8.92064 21.3269C8.92064 21.5565 8.82946 21.7766 8.66717 21.9389C8.50488 22.1012 8.28477 22.1923 8.05525 22.1923C7.82574 22.1923 7.60562 22.1012 7.44333 21.9389C7.28104 21.7766 7.18987 21.5565 7.18987 21.3269C7.19286 21.0984 7.28499 20.88 7.44664 20.7183C7.60828 20.5567 7.82667 20.4646 8.05525 20.4616ZM8.05525 19.0193C7.59883 19.0193 7.15267 19.1546 6.77317 19.4082C6.39367 19.6617 6.09789 20.0222 5.92322 20.4438C5.74856 20.8655 5.70286 21.3295 5.7919 21.7772C5.88094 22.2248 6.10073 22.636 6.42347 22.9587C6.7462 23.2815 7.1574 23.5013 7.60504 23.5903C8.05269 23.6793 8.51669 23.6336 8.93837 23.459C9.36004 23.2843 9.72046 22.9885 9.97403 22.609C10.2276 22.2295 10.3629 21.7834 10.3629 21.3269C10.3629 20.7149 10.1198 20.1279 9.68704 19.6952C9.25426 19.2624 8.66729 19.0193 8.05525 19.0193Z",
    fill: "#24293D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0552 28.3308V26.0231C11.0553 25.8959 11.0297 25.77 10.98 25.6529C10.9303 25.5357 10.8575 25.4299 10.7659 25.3415C10.6744 25.2532 10.5659 25.1843 10.4471 25.1388C10.3283 25.0933 10.2015 25.0723 10.0744 25.077H5.98979C5.74086 25.08 5.50316 25.181 5.32821 25.3581C5.15326 25.5352 5.05516 25.7742 5.05518 26.0231V28.3308",
    stroke: "#24293D",
    strokeWidth: 1.44231,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6091 5.66925V28.3308",
    stroke: "#24293D",
    strokeWidth: 1.44231,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminManage);
export default __webpack_public_path__ + "static/media/AdminManage.10952861c6a3bb222ce8a85d23818db5.svg";
export { ForwardRef as ReactComponent };